var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftDouble = function SvgChevronLeftDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.125 18.654 4.47 12l6.654-6.654L12.179 6.4 6.594 12l5.585 5.6zm7.35 0L11.82 12l6.654-6.654L19.529 6.4 13.944 12l5.585 5.6z"
  })));
};
export default SvgChevronLeftDouble;